import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom';
import moment from 'moment';

// Set moment to use local timezone
moment.locale(navigator.language || 'en');

// Set moment to use local timezone
moment.locale(navigator.language || 'en');

ReactDOM.render(
    <HashRouter>
        <App />
    </HashRouter>, 
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
